var React = require('react');

function Radio16x16 (props) {
    return React.createElement("svg",props,React.createElement("rect",{"x":"1","y":"1.5","width":"14","height":"14","rx":"7","stroke":"currentColor","strokeWidth":"2"}));
}

Radio16x16.defaultProps = {"width":"16","height":"17","viewBox":"0 0 16 17","fill":"none"};

module.exports = Radio16x16;

Radio16x16.default = Radio16x16;
